import React from 'react';

function StartButton() {
  return (
    <a href="#" className="to_top">
      <i className="fal fa-angle-up"></i>
    </a>
  );
}

export default StartButton;
